var $2cd0798cb012f03a$exports = {};
$2cd0798cb012f03a$exports = {
    "endTime": `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    "startTime": `\u{648}\u{642}\u{62A} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    "time": `\u{627}\u{644}\u{648}\u{642}\u{62A}`
};


export {$2cd0798cb012f03a$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
